import { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { daySelector } from 'selectors/calendar'

export const useBookingRedirect = () => {
  const day = useSelector(daySelector)

  const getBookingRedirectUrl = useCallback(() => window.location.href, [])

  const [bookingRedirect, setBookingRedirect] = useState(
    getBookingRedirectUrl()
  )

  useEffect(() => {
    if (day) {
      setBookingRedirect(getBookingRedirectUrl())
    }
  }, [day, getBookingRedirectUrl])

  return {
    encodedBookingRedirect: encodeURIComponent(bookingRedirect),
    bookingRedirect
  }
}
